// Class: starling.extensions.Particle

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var Particle = function() {
	this.x = this.y = this.rotation = this.currentTime = 0.0;
	this.totalTime = this.alpha = this.scale = 1.0;
	this.color = 16777215;
}

// Meta

Particle.__name__ = "starling.extensions.Particle";
Particle.__isInterface__ = false;
Particle.prototype = {
	
};
Particle.prototype.__class__ = Particle.prototype.constructor = $hxClasses["starling.extensions.Particle"] = Particle;

// Init



// Statics




// Export

exports.default = Particle;